<template>
   <div class="form-table">
      <Select 
         v-model="selected_option" 
         :value="selected_option"
         clearable filterable 
         :placeholder="placeholder"
         @input="onSelectChange()" 
      >
         <Option v-for="(item,index) in options" :value="item.val" :key="index">{{ item.label }}</Option>
      </Select>

      <Modal 
         type="simple"
         :show="showModal" 
         @close="closeSelectModal()"
      >
         <template slot="content">
            <div class="modal-content">
               <div class="modal-title">
                  <button class="close" @click="closeSelectModal()" aria-label="Close">
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <Form 
                     class_binding="row" 
                     :ref="name" 
                     :form_data="form_data"
                     :forms="forms"/>

               </div>
               <div class="foot">
                  <div class="btn-box clearfix">
                     <button class="btn btn-primary r" @click="saveChanges()">Save</button>
                  </div>
               </div>
            </div>
         </template>
      </Modal>
   </div>
</template>

<script>
import {Select, Option, OptionGroup} from './select/'

export default {
   components:{
      Form: () => import('./form'),
      Modal: () => import('./modal'),
      Select,
      Option,
      OptionGroup,
   },
   props: {
      name: {
         default: 'form-select'
      },
      placeholder: {
         default: undefined
      },
      options: {
         default: function(){
            return []
         }
      },
      value: {
         default: function(){
            return {
               selected_option: '',
               form_data: {},
            }
         }
      }
   },
   watch:{
      value(newVal){
         if(typeof newVal.form_data === 'object' && this.selected_option !== newVal.selected_option){
            this.selected_option = newVal.selected_option
            this.form_data = newVal.form_data
            this.findForm()
         }
      }
   },
   data () {
      return {
         showModal: false,
         forms: [],
         selected_option: '',
         form_data: {},
      }
   },
   methods: {
      closeSelectModal(){
         this.selected_option = ''
         this.form_data = {}

         this.$emit("input", {
            selected_option: '',
            form_data: {}
         });

         this.showModal = false
      },
      onSelectChange(){
         this.forms = this.findForm()
         if(this.forms){
            this.showModal = true
         }else{
            this.$emit("input", {
               selected_option: this.selected_option,
               form_data: {}
            });
         }
      },
      async saveChanges(){
         if(await this.$refs[this.name].isValid()){
            this.$emit("input", {
               selected_option: this.selected_option,
               form_data: this.$refs[this.name].form_data_
            });
            // this.$emit("input", {
            //    selected_option: this.selected_option,
            //    form_data: this.form_data
            // });
            this.showModal = false
         }
      },
      findForm() {
         for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i];
            
            if(option.val === this.selected_option){
               return option.forms
            }
         }
      },
   },
   mounted(){
      if(this.value.selected_option !== '' && typeof this.value.form_data === 'object'){
         this.selected_option = this.value.selected_option
         this.form_data = this.value.form_data
         this.findForm()
      }
   }
}
</script>